import React from "react";
import Markdown, { MarkdownToJSX } from "markdown-to-jsx";

const CreativeMarkdown: React.FC<{
  [key: string]: any;
  children: string;
  options?: MarkdownToJSX.Options;
}> = ({ children, options, ...props }) => {
  return children ? (
    // eslint-disable-next-line no-useless-escape
    <Markdown {...props} options={{ ...options, disableParsingRawHTML: false }}>
      {children.replace(/#/g, `\u200B\u0023`)}
    </Markdown>
  ) : null;
};

export { CreativeMarkdown };
